import styled from 'astroturf/react'
import { BackButton } from '@calendly/booking-kit'
import _BookingRedesignPhoneBackButton from "BookingRedesignPhoneBackButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/booking_redesign_phone_back_button.js?styleId=BookingRedesignPhoneBackButton";


/** Borderless back control for booking_app_redesign phone layouts (booking-kit adds a circular border by default). */
export const BookingRedesignPhoneBackButton = /*#__PURE__*/styled(BackButton, null, {
  displayName: "BookingRedesignPhoneBackButton",
  styles: _BookingRedesignPhoneBackButton
})
